import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Autocomplete as RTAutocomplete } from 'react-toolbox/lib/autocomplete';

class Autocomplete extends Component {
  componentDidMount() {
    const inputNode = ReactDOM.findDOMNode(this).querySelector('input');
    inputNode.setAttribute('autoComplete', 'new-password');
  }

  render() {
    const { children, ...rest } = this.props;
    return <RTAutocomplete {...rest}>{children}</RTAutocomplete>;
  }
}

export default Autocomplete;



// WEBPACK FOOTER //
// ./src/general-components/Autocomplete.js